import { Outlet } from 'react-router-dom'

const TokenImport = () => <Outlet />

export default TokenImport
